import React, {Fragment} from "react";
import {DLA_WALLET_REDEEM} from "../../../../../const/DeepLinkActionsCostants";
import FuxEvents from "../../../../../lib/FuxFramework/FuxEvents";
import ModalPortalHOC from "../../../../BaseComponents/ModalPortalHOC";
import {RedeemGiftCardPanel} from "./RedeemGiftCardPanel";
import PropTypes from "prop-types";

export class RedeemGiftCardListener extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redeemGiftCardPanelOpen: false,
            secretKey: null,
        }
    }

    componentDidMount() {
        FuxEvents.on(DLA_WALLET_REDEEM, this.handleRedeemGiftOrderPanelOpen);
    }

    componentWillUnmount() {
        FuxEvents.off(DLA_WALLET_REDEEM, this.handleRedeemGiftOrderPanelOpen);
    }

    handleRedeemGiftOrderPanelOpen = (secretKey) => {
        this.setState({secretKey: secretKey, redeemGiftCardPanelOpen: true});
    }
    handleRedeemGiftOrderPanelClose = _ => this.setState({redeemGiftCardPanelOpen: false, secretKey: null});

    render() {
        return (
            <Fragment>
                {
                    this.state.redeemGiftCardPanelOpen &&
                    <ModalPortalHOC>
                        <RedeemGiftCardPanel
                            onDismiss={this.handleRedeemGiftOrderPanelClose}
                            secretKey={this.state.secretKey}
                        />
                    </ModalPortalHOC>
                }
            </Fragment>
        );
    }
}

RedeemGiftCardListener.propTypes = {
    onDismiss: PropTypes.func
}